export default "__VITE_ASSET__Ckhx1Shi__"